<template>
  <div class="p-top-slider u-center swiper-container-top-slider" v-if="banner_list != null">
    <img src="/src/assets/img/common/slider-arrow-prev.png" alt="＜" class="slide-arrow prev-arrow">
    <div class="swiper-wrapper">
      <div class="p-top-slider__item swiper-slide" v-for="(banner, index) in banner_list" :key="index">
        <a :href="banner.LINK_URL">
          <img :src="banner.banner_file_path" :alt="banner.ALT_TXT">
        </a>
      </div>
    </div>
    <img src="/src/assets/img/common/slider-arrow-next.png" alt="＞" class="slide-arrow next-arrow">
    <div class="swiper-pagination"></div>
  </div>
</template>

<script>
export default {
  props: [
    'banner_list',
  ],
  data () {
    return {
      swiperOptions: {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        slidesPerView: 1,
        loop: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        allowTouchMove: true,
        breakpoints: {
          767: {
            slidesPerView: 3,
            loop: true,
            navigation: {
              nextEl: '.slide-arrow.next-arrow',
              prevEl: '.slide-arrow.prev-arrow',
            },
          }
        }
      },
      swiper: null
    }
  },
  mounted() {
    this.$nextTick(() => {
      // Swiperの初期化
      this.swiper = new window.Swiper('.swiper-container-top-slider', this.swiperOptions);
    });
  },
}
</script>

<style>
  .p-top-slider.u-center .swiper-slide{
    width: 320px;
    margin: 0;
    padding: 0 6px;
  }
  @media screen and (max-width: 767px) {
    .p-top-slider.u-center .swiper-slide{
      width: 100%;
      margin: 0;
    }
  }
</style>

<style lang="scss" scoped>
  .swiper-container-top-slider {
      margin-left: auto;
      margin-right: auto;
      padding-bottom: 20px;
      position: relative;
      overflow: hidden;
      list-style: none;
      z-index: 1;
  }

  .swiper-pagination {
    position: relative !important;
  }

  .swiper-pagination-bullets {
      top: 20px;
      left: 0;
  }

  :deep(.swiper-pagination-bullet) {
    background-color: #000;
    border-radius: 50%;
    display: inline-block;
    height: 6px;
    margin: 0 5px;
    width: 6px;
  }

  :deep(.swiper-pagination-bullet-active) {
    background-color: #00b3d6;
  }

  .p-top-slider {
    margin-bottom: 0;
  }

  @media screen and (max-width: 767px) {
    :deep(.swiper-pagination-bullet) {
      height: 10px;
      width: 10px;
    }
  }
</style>
